import type { LegalNavItem } from '../../types/legal'

export const legalNav: LegalNavItem[] = [
  { slug: 'terms', label: 'Terms of service' },
  { slug: 'privacy', label: 'Privacy policy' },
  { slug: 'cookies', label: 'Cookie policy' },
  { slug: 'acceptable-use', label: 'Acceptable use' },
  { slug: 'fees', label: 'Fee schedule' },
  { slug: 'complaints', label: 'Complaints & dispute resolution' },
  { slug: 'lending', label: 'Lending terms & disclosures' },
]

export const legalContact = {
  email: '[legal email]',
  address: '57A KG 215 St, Kigali',
}
